<template>
    <div style="width:85%;margin:auto;padding-top:10px;color:#7b7c87">
        
        <v-layout row wrap>
            <v-flex xs12 md12 lg12 xl12 style="padding:15px;padding-bottom:2px !important"><!--Row #1-->
                <v-layout row wrap>
                    <v-flex xs12 sm12 md10 lg10 xl10 style="padding:15px;padding-bottom:0px;">
                    <div style="padding-top:23px;font-weight:bolder;font-size:20px">مدیریت  آدرس ها</div>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex xs12 md12 lg12 xl12 style="padding:15px;"><!--Row #2-->
                <v-card>
                    <v-card-title>
                        <v-layout row wrap>
                            <v-flex xs12 sm12 md7 lg7 xl7 style="padding-right:15px;padding-left:15px;">
                                <v-text-field outlined dense color="#262d47" placeholder="جستجو" v-model="searchcategory" append-icon="fas fa-search"></v-text-field>   
                            </v-flex>
                            <v-flex xs12 sm12 md5 lg5 xl5 style="padding-right:15px;padding-left:5px;">
                                <v-btn outlined color="#4CAF50" @click="CatCreationDialog = true" dark><v-icon small style="padding-left:5px;">fa fa-plus</v-icon>&nbsp;آدرس جدید</v-btn>&nbsp;
                                <JsonExcel style="display: inline-block;padding-left: 5px;" :data="originalItems" :name="(Math.floor(Math.random() * (1254152541 - 1111 + 1)) + 1111).toString()" :fields="ExportDataColumns">
                                  <v-btn outlined color="#2a2d45" dark><v-icon small style="padding-left:5px;">fa fa-file-export</v-icon>&nbsp;دریافت اکسل</v-btn>&nbsp;
                                </JsonExcel>
                            </v-flex>
                        </v-layout>
                    </v-card-title>
                    <v-card-text>
                        <v-data-table no-data-text="رکوردی یافت نشد" no-results-text="رکوردی یافت نشد" :footer-props="{'items-per-page-text':'آیتم در هر صفحه :','items-per-page-all-text':'همه'}"  items-per-page-text="تعداد در هر صفحه" dense :loading="isLoadingItems" :headers="CatTableHeader" :search="searchcategory" :items="CatTableItems">
                            <template v-slot:[`item.a_Status`]="{ item }">
                               <v-btn small text color="#D32F2F" @click="ActiveItem(item.a_Id)" dark v-if="!item.a_Status">غیر فعال</v-btn>
                               <v-btn small text color="#2E7D32" @click="DisableItem(item.a_Id)" dark v-else> فعال</v-btn>
                            </template>
                            <template v-slot:[`item.a_HexColor`]="{ item }">
                               <v-badge left :color="item.a_HexColor" dot>
                                 {{item.a_HexColor}}
                                </v-badge>
                            </template>
                           
                            <template v-slot:[`item.operation`]="{ item }">
                                <v-btn text icon small color="blue accent-4" @click="editItem(item)"><v-icon small>fas fa-edit</v-icon></v-btn>
                                <v-btn text icon small color="red accent-4" @click="confirmDeleteItem(item.a_Id)"><v-icon small>fas fa-trash</v-icon></v-btn>&nbsp;
                            </template>

                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
        <template><!--Add New Cat From Dialog-->
            <v-dialog max-width="500" persistent v-model="CatCreationDialog">
                <v-card>
                  <v-card-title style="padding:0px !important">
                      <v-app-bar dense color="rgb(42, 45, 69)" dark>
                          <v-toolbar-title style="color:orange">
                              <span v-if="!inEditingItem">ثبت آدرس جدید  </span>
                              <span v-else>ویرایش  آدرس  &nbsp; <v-btn small outlined color="red" @click="cancelEditItem"><v-icon small style="padding-left:5px;">fa fa-times</v-icon>&nbsp;لغو ویرایش</v-btn></span>
                          </v-toolbar-title>
                          <v-spacer></v-spacer>
                          <v-icon color="orange" @click="CatCreationDialog = false" small>fa fa-times</v-icon>
                      </v-app-bar>
                  </v-card-title>
                  <v-card-text>
                      <v-layout row wrap>
                          <v-flex xs12 md12 lg12 xl12 style="padding:15px;"><!--Row #2-->
                            <v-layout row wrap style="flex-wrap:wrap-reverse !important;">
                                <v-flex xs12 sm12 md12 lg12 xl12 style="padding:15px;padding-top:0px !important;"><!--Register New Color From-->
                                   
                                    <v-text-field color="#2a2d45" outlined dense v-model="AddressTitle" label="عنوان" ></v-text-field>
                                    <v-text-field color="#2a2d45" outlined dense v-model="AddressTel" label="تلفن" ></v-text-field>
                                    <v-text-field color="#2a2d45" outlined dense v-model="AddressFax" label="فکس" ></v-text-field>
                                    <v-text-field color="#2a2d45" outlined dense v-model="ZipCode" label="کد پستی" ></v-text-field>
                                    <v-text-field color="#2a2d45" outlined dense v-model="AddressEmail" label="پست الکترونیکی" ></v-text-field>
                                    <v-text-field color="#2a2d45" outlined dense v-model="AddressLat" label="عرض جغرافیایی" ></v-text-field>
                                    <v-text-field color="#2a2d45" outlined dense v-model="AddressLng" label="طول جغرافیایی" ></v-text-field>
                                    <v-text-field color="#2a2d45" outlined dense v-model="AddressSort" label="ترتیب نمایش" ></v-text-field>
                                    <v-textarea color="#2a2d45" outlined dense v-model="Address" label="آدرس" ></v-textarea>
                                    <v-row>
                                        <v-col cols="8">وضعیت :</v-col>
                                        <v-col cols="4" style="display: flex;justify-content: flex-end;">
                                        <v-switch
                                            v-model="addressStatus"
                                            style="padding-top:0px !important;margin-top:0px !important"
                                            color="#2a2d45"
                                        ></v-switch>
                                        </v-col>
                                    </v-row>
                                   
                                   
                                   
                                    <v-btn style="margin-top:20px;" @click="registerItem" outlined dark block color="blue"><v-icon small style="padding-left:5px;">fa fa-check</v-icon>&nbsp; ذخیره</v-btn>
                                
                                </v-flex>
                            </v-layout>
                        </v-flex>
                      </v-layout>
                  </v-card-text>
                </v-card>
            </v-dialog>
        </template>
        <template><!--Loading Dialog-->
            <div class="vld-parent">
                <loading color="#f75314" :width="parseInt(45)" :height="parseInt(45)" background-color="#fff" :active.sync="isLoading" 
                :is-full-page="true"></loading>
                
               
            </div>
        </template>
        <template><!--Delete Confirm Dialog-->
            <v-dialog max-width="450" persistent v-model="ConfirmItemDeleteDialog">
                <v-card>
                    <v-card-title style="padding:0px !important">
                        <v-app-bar dense color="rgb(42, 45, 69)" dark>
                            <v-toolbar-title style="color:orange">حذف دائمی</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-icon color="orange" @click="ConfirmItemDeleteDialog = false" small>fa fa-times</v-icon>
                        </v-app-bar>
                    </v-card-title>
                    <v-card-text style="padding-top:15px;">
                        <v-alert type="error" outlined>
                            کاربر گرامی ؛ رکورد مورد نظر به همراه تمام زیر مجموعه های آن به صورت دائمی حذف خواهند شد.ادامه میدهید؟
                        </v-alert>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-btn outlined :loading="deleteBtnLoading" color="error" @click="DeleteItem"><v-icon small style="padding-left:5px;">fa fa-trash</v-icon>&nbsp; بله</v-btn>&nbsp;
                        <v-btn outlined @click="ConfirmItemDeleteDialog = false" color="info"><v-icon small style="padding-left:5px;">fa fa-times</v-icon>&nbsp; خیر</v-btn>&nbsp;
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </template>
    </div>
</template>
<style>
.v-color-picker__canvas canvas
{
    display: block !important;
    min-width: 100% !important;
    height: 100% !important;
}
</style>
<script>
const axios = require("axios");
const ApiUrl = require('../../../constant/apiurl');
const MSGHNDL = require('../../../constant/MessageHandler');
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import JsonExcel from 'vue-json-excel'
export default {
    name:"addresses",
   components: {
            Loading,
            JsonExcel
        },
    data:()=> ({
        ConfirmItemDeleteDialog:false,
        isLoading:false,
        CatCreationDialog:false,
        searchcategory:"",
        isLoadingItems:false,
        CatTableHeader:
        [
            {text:"#",value:"counter",sortable:true,align:"right"},
            {text:"عنوان ",value:"a_Title",sortable:true,align:"right"},
            {text:"آدرس ",value:"a_Address",sortable:true,align:"right"},
            {text:"وضعیت",value:"a_Status",sortable:true,align:"right"},
            {text:"عملیات",value:"operation",sortable:true,align:"right"},
        ],
        CatTableItems:
        [
        ],
        AddressTitle:"",
        ColorHexCode:"",
        originalItems:[],
        inEditingItem:false,
        EditSelectedItem:{},
        deleteItemId:0,
        deleteBtnLoading:false,
        ExportDataColumns:{
            "عنوان":"a_Title",
            "آدرس":"a_Address",
            "وضعیت":"a_Status"
        },
        AddressTel:"",
        AddressEmail:"",
        AddressLat:"",
        AddressLng:"",
        AddressSort:1,
        Address:"",
        addressStatus:true,
        ZipCode:"",
        AddressFax:""
    }),
    async created()
    {
        let vm = this;
       axios.interceptors.request.use((config) => {
            vm.isLoading = true;
            return config;
        }, (error) => {
            vm.isLoading = false;
            return Promise.reject(error);
        });

        axios.interceptors.response.use((response) => {
            vm.isLoading = false;
            return response;
        }, (error) => {
            vm.isLoading = false;
            return Promise.reject(error);
        });
       var to = window.setTimeout(async ()=>{
           await vm.loadItems();
       },1500);
    },
    computed:{
        LANG(){
        return this.$store.getters.GetLang;
        }
    },
     watch:{
        LANG(nL,oL){
        this.loadItems();
        }
    },
    methods:{
        async DeleteItem()
        {
            let vm = this;
            vm.deleteBtnLoading = true;
            let Model = {};
            Model.a_Id = vm.deleteItemId;
            await axios.post(ApiUrl.DeleteAddress,Model)
            .then(async (res)=>{
                vm.deleteBtnLoading = false;
                let data = res.data;
                if(data.status)
                {
                    MSGHNDL.OK(data.msg);
                    vm.ConfirmItemDeleteDialog = false;
                    await vm.loadItems();
                }
                else
                {
                    MSGHNDL.ERR(data.msg);
                }
            })
            .catch((err)=>{
                vm.deleteBtnLoading = false;
                MSGHNDL.ERR(err);
            });
        },
        confirmDeleteItem(id)
        {
            let vm = this;
            vm.ConfirmItemDeleteDialog = true;
            vm.deleteItemId = id;
        },
        async ActiveItem(id)
        {
            let vm = this;
            let Model = {};
            Model.a_Id = id;
            await axios.post(ApiUrl.ActiveAddress,Model)
            .then(async (res)=>{
                let data = res.data;
                if(data.status)
                {
                    MSGHNDL.OK(data.msg);
                    await vm.loadItems();
                }
                else
                {
                    MSGHNDL.ERR(data.msg);
                }
            })
            .catch((err)=>{
                MSGHNDL.ERR(err);
            });
        },
        async DisableItem(id)
        {
            let vm = this;
            let Model = {};
            Model.a_Id = id;
            await axios.post(ApiUrl.DisableAddress,Model)
            .then(async (res)=>{
                let data = res.data;
                if(data.status)
                {
                    MSGHNDL.OK(data.msg);
                    await vm.loadItems();
                }
                else
                {
                    MSGHNDL.ERR(data.msg);
                }
            })
            .catch((err)=>{
                MSGHNDL.ERR(err);
            });
        },
        cancelEditItem()
        {
            let vm = this;
            vm.CatCreationDialog = false;
            vm.AddressTitle = "";
            vm.AddressTel = "";
            vm.AddressFax = "";
            vm.ZipCode = "";
            vm.AddressEmail = "";
            vm.AddressLat = "";
            vm.AddressLng = "";
            vm.AddressSort = 0;
            vm.Address = "";
            vm.inEditingItem = false;
            vm.EditSelectedItem = {};
            vm.addressStatus = true;
        },
        editItem(item)
        {
            let vm = this;
            vm.CatCreationDialog = true;
            vm.AddressTitle = item.a_Title;
            vm.Address = item.a_Address;
            vm.AddressTel = item.a_Tel;
            vm.AddressFax = item.a_Fax;
            vm.ZipCode = item.a_Zip;
            vm.AddressEmail = item.a_Email;
            vm.AddressLat = item.a_Lat;
            vm.AddressLng = item.a_Lng;
            vm.addressStatus = item.a_Status;
            vm.AddressSort = item.a_Sort;
            vm.inEditingItem = true;
            vm.EditSelectedItem = item;
        },
        async loadItems()
        {
            let vm = this;
            vm.isLoadingItems = true;

            await axios.post(ApiUrl.LoadAddress+"/"+vm.LANG).then((res)=>{
                vm.isLoadingItems = false;
                let data = res.data;
                console.warn(data);
                if(data.status)
                {
                    vm.CatTableItems = data.data;
                    vm.originalItems = data.data;
                    
                }
            }).catch((err)=>{
                vm.isLoadingItems = false;
                console.error(err);
            });
        },
        async registerItem()
        {
            let vm = this;
            let Model = {};
            Model.A_Title = vm.AddressTitle;
            Model.A_Address = vm.Address;
            Model.A_Tel = vm.AddressTel;
            Model.A_Zip = vm.ZipCode;
            Model.A_Fax = vm.AddressFax;
            Model.A_Email = vm.AddressEmail;
            Model.A_Lat = vm.AddressLat;
            Model.A_Lng = vm.AddressLng;
            Model.A_Sort = vm.AddressSort;
            Model.A_Status = vm.addressStatus;
            Model.Lang = vm.LANG;
          
            let url = ApiUrl.addAddress;
            if(vm.inEditingItem)
            {
                Model.A_Id = vm.EditSelectedItem.a_Id;
                Model.Lang = vm.EditSelectedItem.lang;
                url = ApiUrl.updateAddress;
            }
            await axios.post(url,Model).then(async (res)=>{
                let data = res.data;
                if(data.status)
                {
                    vm.loadItems();
                    vm.cancelEditItem();
                    MSGHNDL.OK(data.msg);
                }
                else
                {
                    MSGHNDL.ERR(data.msg);
                }
            }).catch((err)=>{console.warn(err)});
        }
    }
}
</script>